import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { AuthForm } from './auth/AuthForm';
import { motion } from 'framer-motion';

interface LoginPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSignIn: () => void;
}

export function LoginPopup({ isOpen, onClose, onSignIn }: LoginPopupProps) {
  const [mode, setMode] = useState<'login' | 'signup'>('signup');

  const handleSuccess = () => {
    onSignIn();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle className="text-center">
          {mode === 'login' ? 'Welcome Back' : 'Get Full Analysis Access'}
        </DialogTitle>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="text-center"
        >
          <h2 className="text-2xl font-bold mb-4">
            {mode === 'login' ? 'Sign in to continue' : 'Create an account to unlock full analysis'}
          </h2>
          <p className="text-gray-600 mb-6">
            {mode === 'login' 
              ? 'Access your account to view complete analysis'
              : 'Get detailed insights and recommendations for your website'
            }
          </p>
          
          <AuthForm mode={mode} onSuccess={handleSuccess} />
          
          <div className="mt-4 text-sm text-gray-600">
            {mode === 'login' ? (
              <p>
                Don't have an account?{' '}
                <button
                  onClick={() => setMode('signup')}
                  className="text-green-500 hover:text-green-600 font-medium"
                >
                  Sign up
                </button>
              </p>
            ) : (
              <p>
                Already have an account?{' '}
                <button
                  onClick={() => setMode('login')}
                  className="text-green-500 hover:text-green-600 font-medium"
                >
                  Sign in
                </button>
              </p>
            )}
          </div>
        </motion.div>
      </DialogContent>
    </Dialog>
  );
}